module.exports = __webpack_public_path__ + "static/media/Tom Vollaro.965a5f6e.png";